import * as React from 'react';
import { AppServices } from '../../../AppServices';
import { UserContext } from '../../../store/Models/UserContext';

// ===============================================================================

//
// All Toxnot Components have the following resources from the global
// application state in their props
//
export interface ToxnotComponentProperties {
    appServices: AppServices;
}

// ===============================================================================

//
// Contains common methods used by all Toxnot app components that connect with
// application state.
//
export class ToxnotComponent<P extends ToxnotComponentProperties, S = {}, SS = any> extends React.PureComponent<P, S, SS> {
    // helper wrapper, see comment in AppServices
    protected localizeString(s: string): string {
        return this.props.appServices.localizeString(s);
    }

    protected setLanguage(s: string): void {
        this.props.appServices.setUserCultureName(s);
    }

    // ===============================================================================

    // helper wrapper, see comment in AppServices
    protected localizeStringFormat(formatString: string, ...args: any[]) {
        return this.props.appServices.localizeStringFormat(formatString, args);
    }

    //helper wrapper to get the display name for the culture
    protected getLocalizedDisplayNameForCultureName(cultureName: string): string {
        return this.props.appServices.getLocalizedDisplayNameForCultureName(cultureName);
    }

    // ===============================================================================

    protected getQueryParameter(queryParameter: string) {
        return new URLSearchParams(document.location.search).get(queryParameter);
    }

    // ===============================================================================

    protected getUserContext(): UserContext | null {
        return this.props.appServices.userContext;
    }

    // ===============================================================================

    protected getCshtmlRpcParameter<TModel>(): TModel | null {
        const rpcId = this.getQueryParameter("cshtmlRpcId");

        if (rpcId === null) {
            return null;
        }

        const serializedParameterValue = localStorage.getItem(rpcId);

        if (serializedParameterValue === null) {
            return null;
        }

        localStorage.removeItem(rpcId);

        return JSON.parse(serializedParameterValue) as TModel;
    }

    // ===============================================================================

    protected showModal(modalId: string) {
        $('#' + modalId).modal('show');
    }

    // ===============================================================================

    protected hideModal(modalId: string) {
        $('#' + modalId).modal('hide');
    }
}
